import { PatchCulpritCertificationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritCertification/patchCulpritCertificationQuery.type';
import { patchCulpritCertificationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritCertification/patchCulpritCertificationQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchCulpritCertificationQueryOptions = () => {
  return useMutation({
    mutationKey: ['CulpritCertification'],
    mutationFn: (params: PatchCulpritCertificationQueryParamsType) =>
      patchCulpritCertificationFunction(params),
  });
};
